@if (type == "info") {
  <div class="info-screen">
    <div class="row">
      <div class="col-md-7">
        <div class="info-screen-text-container">
          <div class="content">
            <h1>
              {{ title }}
              <span class="highlight">{{ highlightedText }}</span>
            </h1>
            <p [innerHTML]="description"></p>
            <ol>
              <li *ngFor="let item of listItems">
                {{ item }}
              </li>
            </ol>

            @if (languageOptions.length > 0) {
              <div class="language-select-group">
                <span class="language-label">{{ languageLabel }}</span>
                <div ngbDropdown [display]="'static'" class="language-dropdown">
                  <button
                    type="button"
                    class="btn language-dropdown-toggle"
                    id="questionnaire-language"
                    ngbDropdownToggle
                  >
                    {{ selectedLanguageLabel }}
                  </button>
                  <div ngbDropdownMenu aria-labelledby="questionnaire-language">
                    <button
                      *ngFor="let language of languageOptions"
                      type="button"
                      ngbDropdownItem
                      [class.active]="language.value === selectedLanguage"
                      (click)="onLanguageChange(language.value)"
                    >
                      {{ language.label }}
                    </button>
                  </div>
                </div>
                @if (languageHelpText) {
                  <p class="language-help-text">{{ languageHelpText }}</p>
                }
              </div>
            }

            <button class="btn btn-primary" (click)="this.onClick()">
              {{ buttonText }}
            </button>
            <p class="contact-link" *ngIf="contactLink">
              Need help with the process?
              <a (click)="openContactModal()">Contact Us</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-5 progress-tracker-container">
        <app-progress-tracker [steps]="steps"></app-progress-tracker>
      </div>
    </div>
  </div>
} @else if (type == "consent-signed") {
  <div class="email-verification-screen">
    <div class="icon-wrapper">
      <i class="bi bi-check-circle-fill email-icon" style="color: #219653; font-size: 64px;"></i>
    </div>
    <h2>You have signed the consent form!</h2>
    <p class="explore-journey">
      You can now <a [routerLink]="'/journey'">explore your journey</a>
    </p>
  </div>
}
